import { DatePicker } from '@mui/lab';
import { TextField } from '@mui/material';
import { WidgetProps } from '@rjsf/core';

export default function DatePickerWidget({ label, value, required, onChange }: WidgetProps) {
  return (
    <DatePicker
      value={value}
      onChange={onChange}
      renderInput={(params) => <TextField {...params} label={`${label} ${required ? ' *' : ''}`} fullWidth />}
    />
  );
}
